import { ALERT__16, ALERT_WARNING__16, INFO__16, SUCCESS__16 } from '@homeaway/svg-defs/';
var MESSAGE_TYPE = {
  NONE: 'none',
  HELP: 'help',
  ERROR: 'danger',
  WARN: 'warn',
  INFO: 'info',
  SUCCESS: 'success'
};
var ANIMATION_TYPE = {
  TRANSITION: 'TRANSITION',
  SHAKE: 'SHAKE'
};
var TRANSITION_STATE = {
  ENTER: 'ENTER',
  ENTERING: 'ENTERING',
  ENTERED: 'ENTERED',
  EXIT: 'EXIT',
  EXITING: 'EXITING',
  EXITED: 'EXITED'
};
var duration = 500;
var durationMultiplier = 0.45;
var SETTINGS = {
  SHAKE_DURATION: 600,
  TRANSITION_DURATION: duration,
  TRANSITION_DELAY: duration * durationMultiplier,
  TRANSITION_DURATION_WITH_DELAY: duration - duration * durationMultiplier,
  LINE_HEIGHT: 18,
  NO_MAX_COUNT_MAX_HEIGHT: 200
};
var inlineMessageUtil = {
  isIcon: function isIcon(type) {
    return type !== MESSAGE_TYPE.NONE && type !== MESSAGE_TYPE.HELP;
  },
  getIconTypeToUse: function getIconTypeToUse(_ref) {
    var type = _ref.type,
        prevType = _ref.prevType,
        animate = _ref.animate;
    return animate && (type === MESSAGE_TYPE.HELP || type === MESSAGE_TYPE.NONE) ? prevType : type;
  },
  getIconMarkup: function getIconMarkup(_ref2) {
    var _MESSAGE_TYPE$INFO$ME;

    var type = _ref2.type,
        prevType = _ref2.prevType,
        animate = _ref2.animate;
    var typeToUse = inlineMessageUtil.getIconTypeToUse({
      type: type,
      prevType: prevType,
      animate: animate
    });
    return (_MESSAGE_TYPE$INFO$ME = {}, _MESSAGE_TYPE$INFO$ME[MESSAGE_TYPE.INFO] = INFO__16, _MESSAGE_TYPE$INFO$ME[MESSAGE_TYPE.WARN] = ALERT_WARNING__16, _MESSAGE_TYPE$INFO$ME[MESSAGE_TYPE.ERROR] = ALERT__16, _MESSAGE_TYPE$INFO$ME[MESSAGE_TYPE.SUCCESS] = SUCCESS__16, _MESSAGE_TYPE$INFO$ME)[typeToUse] || '';
  },
  getAdjustedType: function getAdjustedType(message, type) {
    if (type === void 0) {
      type = MESSAGE_TYPE.ERROR;
    }

    return message === '' || !message ? MESSAGE_TYPE.NONE : type;
  },
  // eslint-disable-next-line complexity
  computeAnimationType: function computeAnimationType(_ref3) {
    var type = _ref3.type,
        prevType = _ref3.prevType,
        noAnimation = _ref3.noAnimation;
    return {
      iconToIcon: inlineMessageUtil.isIcon(prevType) && inlineMessageUtil.isIcon(type),
      iconToHelp: inlineMessageUtil.isIcon(prevType) && type === MESSAGE_TYPE.HELP,
      helpToIcon: prevType === MESSAGE_TYPE.HELP && inlineMessageUtil.isIcon(type),
      iconToNone: inlineMessageUtil.isIcon(prevType) && type === MESSAGE_TYPE.NONE,
      noneToIcon: prevType === MESSAGE_TYPE.NONE && inlineMessageUtil.isIcon(type),
      anyToNone: prevType !== MESSAGE_TYPE.NONE && type === MESSAGE_TYPE.NONE,
      noneToAny: prevType === MESSAGE_TYPE.NONE && type !== MESSAGE_TYPE.NONE,
      noAnimation: !!noAnimation,
      type: type !== prevType ? prevType + "-to-" + type : ''
    };
  },
  generateEnterExitStyles: function generateEnterExitStyles(_ref4) {
    var _ref5;

    var mTop = _ref4.mTop,
        mBottom = _ref4.mBottom,
        maxLineCount = _ref4.maxLineCount,
        _ref4$noAnimation = _ref4.noAnimation,
        noAnimation = _ref4$noAnimation === void 0 ? false : _ref4$noAnimation;
    var hasMaxCount = maxLineCount > 0;
    var marginTop = mTop + "px";
    var marginBottom = mBottom + "px";
    var maxHeight = maxLineCount * SETTINGS.LINE_HEIGHT + "px";
    var transitionAndEase = SETTINGS.TRANSITION_DURATION_WITH_DELAY + "ms ease";
    var transitionAndEaseWithDelay = SETTINGS.TRANSITION_DURATION_WITH_DELAY + "ms ease " + SETTINGS.TRANSITION_DELAY + "ms";

    if (!hasMaxCount) {
      maxHeight = '';
      transitionAndEase = '0ms ease';
      transitionAndEaseWithDelay = "0ms ease " + SETTINGS.TRANSITION_DURATION_WITH_DELAY + "ms";
    }

    return _ref5 = {}, _ref5[TRANSITION_STATE.ENTER] = {
      maxHeight: '0',
      marginTop: '0',
      marginBottom: '0',
      transition: 'none'
    }, _ref5[TRANSITION_STATE.ENTERING] = {
      maxHeight: maxHeight,
      marginTop: marginTop,
      marginBottom: marginBottom,
      transition: noAnimation ? 'none' : "max-height " + transitionAndEase + ", margin-top " + transitionAndEase + ", margin-bottom " + transitionAndEase
    }, _ref5[TRANSITION_STATE.ENTERED] = {
      maxHeight: '',
      marginTop: marginTop,
      marginBottom: marginBottom,
      transition: 'none'
    }, _ref5[TRANSITION_STATE.EXIT] = {
      maxHeight: hasMaxCount ? maxHeight : SETTINGS.NO_MAX_COUNT_MAX_HEIGHT + "px",
      marginTop: marginTop,
      marginBottom: marginBottom,
      transition: 'none'
    }, _ref5[TRANSITION_STATE.EXITING] = {
      maxHeight: '0',
      marginTop: '0',
      marginBottom: '0',
      transition: noAnimation ? 'none' : "max-height " + transitionAndEaseWithDelay + ", margin-top " + transitionAndEaseWithDelay + ", margin-bottom " + transitionAndEaseWithDelay
    }, _ref5[TRANSITION_STATE.EXITED] = {
      maxHeight: '0',
      marginTop: '0',
      marginBottom: '0',
      transition: 'none'
    }, _ref5;
  }
};
export { MESSAGE_TYPE, ANIMATION_TYPE, TRANSITION_STATE, SETTINGS, inlineMessageUtil };
export default inlineMessageUtil;
//# sourceMappingURL=inlineMessageUtil.js.map